import React from "react";
import { CONFIG } from "../../config/keys";
import axios from "axios";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";

class RecordEdit extends React.Component {
  render() {
    const updateRecord = formValues => {
      let updatedata = "";
      updatedata = updatedata + "{";
      updatedata = updatedata + 'Name: "' + formValues.Name + '",';
      updatedata = updatedata + 'ColorCode: "' + formValues.ColorCode + '"';
      updatedata = updatedata + "}";
      //console.log(updatedata);
      if (formValues.Oid) {
        // UPDATE RECORD
        const RecordEditQuery = `/${this.props.ReferenceTable}(${parseInt(
          formValues.Oid
        )})`;
        axios({
          method: "put",
          url: CONFIG.API_URL + RecordEditQuery,
          data: updatedata,
          headers: {
            "Content-Type": "application/json",
            Auth: CONFIG.API_KEY
          }
        })
          .then(result => {
            this.props.handleCloseReload();
          })
          .catch(error => console.log(error));
      } else {
        // CREATE RECORD
        const AddRecordQuery = `/${this.props.ReferenceTable}`;
        axios({
          method: "post",
          url: CONFIG.API_URL + AddRecordQuery,
          data: updatedata,
          headers: {
            "Content-Type": "application/json",
            Auth: CONFIG.API_KEY
          }
        })
          .then(result => {
            this.props.handleCloseReload();
          })
          .catch(error => console.log(error));
      }
    };
    const onSubmit = formValues => {
      // console.log(formValues);
      updateRecord(formValues);
    };
    return (
      <div className="txt-center">
        <h4>{this.props.ReferenceTable}</h4>
        <form onSubmit={this.props.handleSubmit(onSubmit)}>
          <div>
            <Field
              name="Oid"
              component="input"
              type="hidden"
              autoComplete="off"
            />
          </div>
          <div>
            <label>{this.props.ReferenceTable} Name</label>
            <div>
              <Field
                name="Name"
                component="input"
                type="text"
                placeholder={this.props.ReferenceTable + " Name"}
                autoComplete="off"
              />
            </div>
            <div>
              <Field
                name="ColorCode"
                component="input"
                type="text"
                placeholder={this.props.ReferenceTable + " ColorCode"}
                autoComplete="off"
              />
            </div>
          </div>
          <button className="waves-effect waves-light btn btn-small">
            Submit
          </button>
          &nbsp;
          <button
            type="button"
            className="waves-effect waves-light btn btn-small"
            onClick={this.props.handleClose}
          >
            Cancel
          </button>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    initialValues: {
      Oid: ownProps.data.Oid,
      Name: ownProps.data.Name,
      ColorCode: ownProps.data.ColorCode
    }
  };
};

const validate = formValues => {
  const errors = {};

  if (!formValues.Name) {
    errors.Name = "Please enter a name";
  }

  return errors;
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "RecordEdit",
    validate
  })(RecordEdit)
);
